import axios from 'axios'
import { store } from '@/store/store'
import config from '@/config'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const allInOneChatApi = {
  getChatLog: (request) => {
    const { data } = request
    return instance().get(`/getchatlog`, { params: data })
  }
}

export default allInOneChatApi



// WEBPACK FOOTER //
// ./src/api/all-in-one-chat.js